import * as React from 'react';
import { createRoot } from 'react-dom/client';
import type { NonInteractiveContinueHandlerType, NonInteractiveRenderViewReturnType, RenderViewPropsType, RenderViewReturnType } from '../types';
import { AdvisorMessage } from '../../../React/features/Chat/features/AdvisorMessage';

export const COMPONENT_IDENTIFIER = 'advisor-message';
const COMPONENT_ROOT_CLASS_NAME = `chat-${COMPONENT_IDENTIFIER}-container`;

export type RenderAdvisorMessagePropsType = RenderViewPropsType<{
  isVisibleAvatar?: boolean;
  avatarName?: string;
  messageElement: React.ReactNode;
  overrideMessageElement?: React.ReactNode;
  balloonContents?: React.ReactNode;
  loadingTime?: number;
  delayTime?: number;
}>

export const renderAdvisorMessage = async (props: RenderAdvisorMessagePropsType): RenderViewReturnType<NonInteractiveRenderViewReturnType> => {
  const { chatRoot, keyName, isVisibleAvatar } = props;

  // レンダーするためのルート要素を作成
  const viewContainer = document.createElement('div');
  const viewRoot = createRoot(viewContainer);

  // 表示関連のフラグを作成
  const isFirstElement = chatRoot.children.length === 0;
  const isConsecutive = !!chatRoot.lastElementChild?.classList.contains(COMPONENT_ROOT_CLASS_NAME);
  const isWithAvatar = isVisibleAvatar !== undefined ? isVisibleAvatar : !isConsecutive;

  // コンテナ要素にクラス付与
  viewContainer.classList.add(COMPONENT_ROOT_CLASS_NAME);
  viewContainer.classList.add(keyName);

  // チャットルートにコンテナ要素をappendする
  chatRoot.appendChild(viewContainer);

  return new Promise((resolve) => {
    const continueHandler = (args: NonInteractiveContinueHandlerType) => resolve({ ...args, viewRootDomReference: viewContainer });

    // appendしたコンテナ要素にJsxをレンダリングする
    viewRoot.render(<AdvisorMessage {...props} continueHandler={continueHandler} isFirstElement={isFirstElement} isWithAvatar={isWithAvatar} />);
  });
};
